import React, { Component} from 'react'
import Cookies from 'js-cookie';
import './Profile.scss'

import profileIcon from 'images/profile-icon.svg'
import { ConfigContext } from 'providers/ConfigContext';
import * as dumbleData from 'DumbleData';


export class Profile extends Component {
	
	static contextType = ConfigContext;
	constructor(props){
		super(props);
		this.state = {
			userFirstName: '',
			userInitials: '',
			dropDownExpandedOnMobile: false,
			myScholasticOrigin: '',
			myScholasticSignInOrigin: '',
			profileDropdownOrderedKeys: [
				"#my-profile",
				"#my-wishlist",
				"#order-history",
				"#subscription-downloads",
				"#manage-campaigns",
				"#gift-card",
				"#sign-out"
			],
			profileDropdownTitles: {
				"#my-profile": "My Profile",
				"#my-wishlist": "My Wishlist",
				"#order-history": "Order History",
				"#subscription-downloads": "Subscriptions & Downloads",
				"#manage-campaigns": "Campaigns",
				"#gift-card": "Gift Card",
				"#sign-out": "Sign Out"
			},
			/* to be merged with response to profile-links endpoint on login */
			profileDropdownLinks: {
				"#sign-out": "/api/logout"
			}
		}

		this.generateDropdownLinks = this.generateDropdownLinks.bind(this);
		this.toggleDropdownOnMobile = this.toggleDropdownOnMobile.bind(this);
		this.generateUserIcon = this.generateUserIcon.bind(this);
		this.renderDropdown = this.renderDropdown.bind(this);
		this.checkSignedInStatus = this.checkSignedInStatus.bind(this);
		this.fetchMyProfileLinks = this.fetchMyProfileLinks.bind(this);
		this.fetchUserData = this.fetchUserData.bind(this);
		this.signoutMyScholastic = this.signoutMyScholastic.bind(this);
		this.setDomainToScholastic = this.setDomainToScholastic.bind(this);
		this.setStrictDomain = this.setStrictDomain.bind(this);
		this.renderMyScholasticModal = this.renderMyScholasticModal.bind(this);
		this.parseUserNameData = this.parseUserNameData.bind(this);
		this.signUserOn = this.signUserOn.bind(this);
		this.myScholasticOnLoginSuccess = this.myScholasticOnLoginSuccess.bind(this);
		this.myScholasticOnRegistrationSuccess = this.myScholasticOnRegistrationSuccess.bind(this);
		this.myScholasticOnLoginClose = this.myScholasticOnLoginClose.bind(this);

		/* assign myScholastic callbacks to top level */
		window.myScholasticOnLoginSuccess = this.myScholasticOnLoginSuccess;
		window.myScholasticOnRegistrationSuccess = this.myScholasticOnRegistrationSuccess;
		window.myScholasticOnLoginClose = this.myScholasticOnLoginClose;

	}

	componentDidMount(){
		/* inject myScholastic env origin into component state */
		this.setState({ myScholasticOrigin: this.context.myschl.origin, myScholasticSignInOrigin: this.context.myschl.signInOrigin }, () => {
			this.checkSignedInStatus();
		})
	}

	checkSignedInStatus(){
		let sps_ud = Cookies.get('SPS_UD');
		if(sps_ud){
			let userNameData = this.parseUserNameData(sps_ud);
			this.setState({...userNameData });
			this.fetchMyProfileLinks();
			this.fetchUserData();
		} else {
			this.props.onSignInChange(false);
		}		
	}

	fetchMyProfileLinks() {
		return fetch(this.state.myScholasticOrigin.concat("/api/profile-links"), {
			method: 'GET',
			credentials: 'include'
		})
		.then((response) => {
			if (response.status === 200) {
				return response.json();
			} else {
				/*
					if there's an sps_ud cookie, but no
					valid schl cookie (user not signed in
					to myscholastic), use myscholastic
					logout endpoint to clear cookies
				*/
				this.signoutMyScholastic();
			}
		})
		.then((data) => {
			/*
				merge returned profile links data with signon link data
			*/
			this.setState({ 
				profileDropdownLinks: {...this.state.profileDropdownLinks, ...data}
			});
			this.props.onSignInChange(true);
		})
		.catch((error) => {
			console.log(error);
			return null;
		})
	}

	fetchUserData() {
		return fetch(this.state.myScholasticOrigin.concat("/api/user"), {
			method: 'GET',
			credentials: 'include'
		}).then((response) => {
			if (response.status === 200) {
				return response.json();
			} else {
				this.signoutMyScholastic();
			}
		})
		.then((data) => {
			if(data.personas.hasOwnProperty('educator')) {
				let gradeBand = data.personas.educator.school.gradeRoles;
				dumbleData.setGrade(gradeBand);
				dumbleData.setUserType('educator');
			} else if(data.personas.hasOwnProperty('parent')) {
				dumbleData.setUserType('parent');
			}
		})
		.catch(error => console.log(error))
	}

	/*
		clears SPS_SESSION, SPS_SESSION_SECURE, SPS_TSP, 
		SPS_TSP_SECURE and SCHL cookies
	*/
	signoutMyScholastic() {
		return fetch(this.state.myScholasticOrigin.concat("/api/logout"), {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
			body: "{}"
		})
		.then(response =>  response.json())
		.then(result => {
			this.setState({ 
				profileDropdownLinks: {
					"#sign-out": "/api/logout"
				}
			});
			this.props.onSignInChange(false);
			console.log('signoutMyScholastic Success:', result);
		})
		.catch(error => {
			console.error('signoutMyScholastic Error:', error);
		});
	}

	/*
		toggle page domain to address CORs issues
		btw myscholastic iframe domain and page
	 */
	setDomainToScholastic() {
		if (document.domain.indexOf("scholastic") !== -1) {
			document.domain = "scholastic." + document.domain.split(".").pop();
		}
	}

	setStrictDomain() {
		// Set up a try-catch to handle issues with this call on Firefox :'(
		try {
			document.domain = document.location.hostname;
		}
		catch(err) {
			console.error(err);
		}
	}

	renderMyScholasticModal(){
		if(this.props.myScholasticModal.isOpen){
			this.setDomainToScholastic();
			return (
				<div className="profile__myscholastic-modal">
					<div className="profile__myscholastic-modal--overlay"></div>
					<div className="profile__myscholastic-modal--container">
						<svg 
							xmlns="http://www.w3.org/2000/svg" 
							width="32" 
							height="32" 
							viewBox="0 0 32 32" 
							className="profile__myscholastic-modal--close"
							onClick={() => {
									this.props.setMyScholasticModal({ isOpen: false, openedFrom: ""});
								}
							}
						>
							<path fill="#333333" fillRule="evenodd" d="M24.146 7.146a.502.502 0 0 1 .766.639l-.058.069L16.708 16l8.146 8.146a.502.502 0 0 1-.708.708L16 16.708l-8.146 8.146a.503.503 0 0 1-.258.137L7.5 25a.502.502 0 0 1-.412-.785l.058-.069L15.292 16 7.22 7.927a.499.499 0 0 1 0-.707.499.499 0 0 1 .707 0L16 15.292l8.146-8.146z"/>
						</svg>
						<iframe 
							className="profile__myscholastic-modal--iframe"
							src={this.state.myScholasticSignInOrigin.concat("/sign-in.html?ref=bw")}
							title="myscholastic-modal"
							frameBorder="0" 
							allowFullScreen>
						</iframe>
					</div>
				</div>
			)
		}
		this.setStrictDomain();
		return null;
	}

	/* parse initials and username from sps_ud cookie and set to UI state */
	parseUserNameData(sps_ud){
		let userNameArray = sps_ud.split('|').filter(function(el,idx){ return idx === 2 || idx === 3});
		let userName = userNameArray[0];
		let userInitials = userNameArray.map(function(el){ return el.slice(0,1).toUpperCase()}).join('');
		return { userFirstName: userName, userInitials: userInitials };
	}

	signUserOn(){
		let sps_ud = Cookies.get('SPS_UD');
		let signOnState = { sps_ud: sps_ud };
		if(sps_ud){
			// If the modal was opened from the checkout button, send user to checkout screen
			if (this.props.myScholasticModal.openedFrom === 'cart') {
				window.location = this.context.tso.demandware.concat('/COCustomer-Start')
			} else if (this.props.myScholasticModal.openedFrom === 'wishlist') {
			}
			let userNameData = this.parseUserNameData(sps_ud);
			this.setState({ ...signOnState, ...userNameData });
			this.fetchMyProfileLinks();
			this.fetchUserData();
		}
	}

	/* MyScholastic top-level hooks (called from within child iframe) */
	myScholasticOnLoginSuccess() {
		this.signUserOn();
	}

	myScholasticOnRegistrationSuccess () {
		this.signUserOn();
	}

	myScholasticOnLoginClose () {
		this.props.setMyScholasticModal({ isOpen: false, openedFrom: ""})
	}

	toggleDropdownOnMobile(){
		this.setState({ dropDownExpandedOnMobile: !this.state.dropDownExpandedOnMobile })
	}

	generateUserIcon(){
		if(this.props.isSignedIn){
			return (
				<div className="profile__icon" onClick={this.toggleDropdownOnMobile} tabIndex="0">
					<div className="profile__icon--signedin">
						<div className="profile__user-initials">{this.state.userInitials}</div>
					</div>
				</div>
			)
		} 
		return (
			<div className="profile__icon" onClick={() => this.props.setMyScholasticModal({ isOpen: true, openedFrom: "profile"})} tabIndex="0">
				<img className="profile__icon--anonymous" src={profileIcon} alt="Profile Icon"/>
			</div>
		)
	}

	generateDropdownLinks() {
		let myScholasticOrigin = this.state.myScholasticOrigin;
		let titles = this.state.profileDropdownTitles;
		let demandware = this.context.tso.demandware;
		let links = this.state.profileDropdownLinks;
		let signoutMyScholastic = this.signoutMyScholastic;
		let linkList = this.state.profileDropdownOrderedKeys.filter(function(key){
			if(links[key]){
				return true;
			}
			return false;
		}).map(function(key,idx){
			if(key === "#sign-out"){
				// eslint-disable-next-line
				return (<div key={idx} id="signout" onClick={signoutMyScholastic} tabIndex='0'>{titles[key]}</div>);
			}
			if (key === "#my-wishlist") {
				return (<a key={idx} target="_blank" rel="noopener noreferrer" href={`${demandware}/Wishlist-Show`}>{titles[key]}</a>);
			}
			return (<a key={idx} target="_blank" rel="noopener noreferrer" href={myScholasticOrigin.concat(links[key])}>{titles[key]}</a>);
		})
		return linkList;
	}

	renderDropdown() {
		if(this.props.isSignedIn){
			return (
				<div className={this.state.dropDownExpandedOnMobile ? 'profile__dropdown expanded': 'profile__dropdown'}> 
					<p className="profile__greeting">Hello, {this.state.userFirstName}</p>
					{this.generateDropdownLinks()}
				</div>
			);
		}
		return null;
	}
	
	
	render() {
		return (
			<div className="profile">
				{this.generateUserIcon()}
				{this.renderDropdown()}
				{this.renderMyScholasticModal()}
			</div>
		)
	}
}

export default Profile
